var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescriptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.529,
    height: 18.652,
    viewBox: "0 0 21.529 18.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prescription-white",
    transform: "translate(-984.632 -474.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M987.977,487.8h0a1.7,1.7,0,0,1,0-2.388l2.809-2.81a1.69,1.69,0,0,1,2.39,2.389l-2.81,2.809A1.694,1.694,0,0,1,987.977,487.8Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1297",
    "data-name": "Line 1297",
    x2: 2.389,
    y2: 2.389,
    transform: "translate(989.39 484)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M996.136,486.052V481.56a1.834,1.834,0,0,0-.437-1.194l-2-2.423",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M987.456,477.926l-2,2.423a1.835,1.835,0,0,0-.438,1.194v9.017a1.882,1.882,0,0,0,1.884,1.885h7.335a1.793,1.793,0,0,0,.943-.253",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1539",
    "data-name": "Rectangle 1539",
    d: "M1.161,0h7.62A1.161,1.161,0,0,1,9.943,1.161V2.187A1.161,1.161,0,0,1,8.782,3.348H1.16A1.16,1.16,0,0,1,0,2.187V1.161A1.161,1.161,0,0,1,1.161,0Z",
    transform: "translate(985.621 474.578)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1298",
    "data-name": "Line 1298",
    y2: 1.211,
    transform: "translate(988.869 475.605)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1299",
    "data-name": "Line 1299",
    y2: 1.211,
    transform: "translate(990.584 475.605)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1300",
    "data-name": "Line 1300",
    y2: 1.211,
    transform: "translate(992.301 475.605)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M1003.858,489a7.418,7.418,0,0,1-4.188.942c-2.322,0-4.189-.791-4.189-1.766,0-.438.369-.825.992-1.144",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M1003.858,490.7c0,.975-1.883,1.766-4.188,1.766-2.322,0-4.189-.791-4.189-1.766",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1301",
    "data-name": "Line 1301",
    y1: 1.699,
    transform: "translate(1003.858 488.996)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1302",
    "data-name": "Line 1302",
    y1: 2.54,
    transform: "translate(995.48 488.155)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M1001.588,482.166q.412,0,.817.034c.27.022.532.056.786.1a7.342,7.342,0,0,1,.724.164,5.357,5.357,0,0,1,.635.219,3.666,3.666,0,0,1,.521.268,2.111,2.111,0,0,1,.387.305,1.221,1.221,0,0,1,.238.332.773.773,0,0,1,0,.689,1.2,1.2,0,0,1-.238.331,2.115,2.115,0,0,1-.387.306,3.662,3.662,0,0,1-.521.267,5.35,5.35,0,0,1-.635.22,7.068,7.068,0,0,1-.724.163c-.254.045-.516.078-.786.1s-.542.034-.817.034-.548-.011-.817-.034-.532-.056-.786-.1a7.014,7.014,0,0,1-.724-.163,5.29,5.29,0,0,1-.635-.22,3.617,3.617,0,0,1-.521-.267,2.117,2.117,0,0,1-.387-.306,1.208,1.208,0,0,1-.239-.331.782.782,0,0,1,0-.689,1.226,1.226,0,0,1,.239-.332,2.113,2.113,0,0,1,.387-.305,3.62,3.62,0,0,1,.521-.268,5.3,5.3,0,0,1,.635-.219,7.283,7.283,0,0,1,.724-.164c.254-.044.516-.078.786-.1S1001.313,482.166,1001.588,482.166Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M1001.587,484.689a5.184,5.184,0,0,1-3.129-.757,5.316,5.316,0,0,1,3.129-.757,5.182,5.182,0,0,1,3.129.757A5.305,5.305,0,0,1,1001.587,484.689Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M1005.776,486.472c0,.976-1.884,1.767-4.189,1.767-2.321,0-4.189-.791-4.189-1.767",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1303",
    "data-name": "Line 1303",
    y1: 2.54,
    transform: "translate(1005.776 483.932)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1304",
    "data-name": "Line 1304",
    y1: 2.54,
    transform: "translate(997.399 483.932)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.768
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionWhite);
export default __webpack_public_path__ + "static/media/prescription-white.046224c0e215aa165b8bc4cdc532b518.svg";
export { ForwardRef as ReactComponent };